<template>
  <v-card class="b-dark education-item">
    <v-card-text>
      <div class="d-flex ga-5">
        <div>
          <img class="item-card-icons" src="@/assets/images/education-icon.svg" />
        </div>
        <div class="d-flex flex-column ga-1 w-100">
          <div class="d-flex justify-space-between w-100 align-center">
            <h4>{{ education.University }}</h4>
            <div class="d-flex ga-2">
              <v-btn v-if="!isHiringmanager" icon="mdi-pen" class="c-black b-white" :disabled="loading" @click="edit" />
              <v-btn v-if="!isHiringmanager" icon="mdi-delete" class="c-black b-white" :disabled="loading" @click="remove" />
            </div>
          </div>
          <span class="f-body-1">{{ education.Degree }} - {{ truncate(education.StudyField, 30) }} </span>
          <span class="f-body-1 mt-5">{{ education.Description ? education.Description : "-" }}</span>
          <span class="f-body-1 mt-5"
            >{{ education.StartDate ? formatDate(education.StartDate) : "" }} {{ education.EndDate ? " - " + formatDate(education.EndDate) : "" }}
            {{ education.StillStudying ? (education.StartDate || education.EndDate ? " - Still Studying" : "Still Studying") : "" }}</span
          >
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<script lang="ts">
import moment from "moment";
import { defineComponent } from "vue";
import Utils from "../../../utils/Utils";

export default defineComponent({
  props: ["education", "isHiringmanager", "loading"],
  data() {
    return {};
  },
  methods: {
    truncate(text: any, length: Number) {
      return Utils.truncate(text, length);
    },
    formatDate(date: any) {
      return moment(date).format("MM/YYYY");
    },
    edit() {
      this.$emit("edit");
    },
    remove() {
      this.$emit("remove");
    },
  },
  mounted() {},
  watch: {},
});
</script>
<style lang="scss">
.education-item {
  min-height: 200px;
}
</style>
